export default "__VITE_ASSET__Df0tiM7x__"